import React, { Suspense, lazy } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import SubmitProject from "@/pages/SubmitProject";
import ProjectsList from "@/pages/ProjectsList";
import ProjectDetail from "@/pages/ProjectDetail";
import SurveysList from "@/pages/SurveysList";
import QuotesList from "@/pages/QuotesList";
import MessagesHub from "@/pages/MessagesHub";

// Admin pages are bundle-heavy and only relevant for admin users.
// Code-split them so customers don't pay the cost on first load.
const AdminPanel = lazy(() => import("@/pages/AdminPanel"));
const AdminCatalog = lazy(() => import("@/pages/AdminCatalog"));
const AdminAuditLog = lazy(() => import("@/pages/AdminAuditLog"));
const AdminInbox = lazy(() => import("@/pages/AdminInbox"));

function LoadingShell() {
  return (
    <div className="flex items-center justify-center min-h-screen" data-testid="route-loading">
      <div className="overline">Loading…</div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Suspense fallback={<LoadingShell />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/projects" element={<ProtectedRoute><ProjectsList /></ProtectedRoute>} />
            <Route path="/projects/new" element={<ProtectedRoute roles={["customer"]}><SubmitProject /></ProtectedRoute>} />
            <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
            <Route path="/quotes" element={<ProtectedRoute><QuotesList /></ProtectedRoute>} />
            <Route path="/surveys" element={<ProtectedRoute><SurveysList /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute><MessagesHub /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPanel /></ProtectedRoute>} />
            <Route path="/admin/inbox" element={<ProtectedRoute roles={["admin"]}><AdminInbox /></ProtectedRoute>} />
            <Route path="/admin/catalog" element={<ProtectedRoute roles={["admin"]}><AdminCatalog /></ProtectedRoute>} />
            <Route path="/admin/audit" element={<ProtectedRoute roles={["admin"]}><AdminAuditLog /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
